var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.729 29.528-3.961-5.23c-2.69-.05-8.13-1.703-8.369-7.919-.297-7.77 5.68-8.816 8.369-8.742 2.688.075 5.976 1.27 7.32 4.558 1.076 2.63.997 5.478.822 6.574l3.586 4.856c1.37-2.266 3.616-7.934 1.644-12.476-2.465-5.678-7.247-9.563-14.195-9.115-6.948.448-12.7 6.5-12.925 12.253-.224 5.752 1.196 10.16 6.276 13.597 4.064 2.75 9.314 2.24 11.43 1.643zM13.75 17.575h4.482c.598 0 2.167.403 3.661 2.017s5.852 7.346 7.845 10.011h-4.632c-.598-.025-2.197-.463-3.81-2.017-1.614-1.554-5.703-7.322-7.546-10.011z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQi);
export default __webpack_public_path__ + "static/media/QI.86857480165fb944642e0cddea1e5dc0.svg";
export { ForwardRef as ReactComponent };